import { render } from "./worldPanel.vue?vue&type=template&id=2ef67e38&scoped=true"
import script from "./worldPanel.vue?vue&type=script&lang=ts"
export * from "./worldPanel.vue?vue&type=script&lang=ts"

import "./worldPanel.vue?vue&type=style&index=0&id=2ef67e38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ef67e38"

export default script